// Hand-drawn SVG illustrations for the children's therapy center

export const Sun = ({ className = "", size = 80 }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 100" fill="none">
    <circle cx="50" cy="50" r="20" fill="#FBE4A8" stroke="#E5C77D" strokeWidth="2.5" />
    <g stroke="#E5C77D" strokeWidth="2.5" strokeLinecap="round">
      <line x1="50" y1="12" x2="50" y2="22" />
      <line x1="50" y1="78" x2="50" y2="88" />
      <line x1="12" y1="50" x2="22" y2="50" />
      <line x1="78" y1="50" x2="88" y2="50" />
      <line x1="22" y1="22" x2="29" y2="29" />
      <line x1="71" y1="71" x2="78" y2="78" />
      <line x1="78" y1="22" x2="71" y2="29" />
      <line x1="22" y1="78" x2="29" y2="71" />
    </g>
    <circle cx="44" cy="46" r="1.8" fill="#5B4F46" />
    <circle cx="56" cy="46" r="1.8" fill="#5B4F46" />
    <path d="M44 55 Q50 60 56 55" stroke="#5B4F46" strokeWidth="1.8" fill="none" strokeLinecap="round" />
  </svg>
);

export const Cloud = ({ className = "", size = 80, color = "#FFFFFF" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 100 60" fill="none">
    <path
      d="M25 45 Q12 45 12 35 Q12 25 22 25 Q24 15 35 15 Q44 15 47 22 Q52 18 58 22 Q68 18 73 28 Q85 28 85 38 Q85 48 75 48 Z"
      fill={color}
      stroke="#D8D2C5"
      strokeWidth="2"
      strokeLinejoin="round"
    />
  </svg>
);

export const Heart = ({ className = "", size = 40, color = "#F4A899" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none">
    <path
      d="M20 35 C20 35 5 25 5 14 C5 8 9 5 14 5 C17 5 20 7 20 11 C20 7 23 5 26 5 C31 5 35 8 35 14 C35 25 20 35 20 35 Z"
      fill={color}
      stroke="#5B4F46"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const Star = ({ className = "", size = 30, color = "#FBE4A8" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 40 40" fill="none">
    <path
      d="M20 5 L24 16 L36 16 L26 23 L30 35 L20 27 L10 35 L14 23 L4 16 L16 16 Z"
      fill={color}
      stroke="#5B4F46"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </svg>
);

export const Rainbow = ({ className = "", size = 200 }) => (
  <svg className={className} width={size} height={size * 0.55} viewBox="0 0 200 110" fill="none">
    <path d="M10 100 Q100 -10 190 100" stroke="#F4A899" strokeWidth="11" fill="none" strokeLinecap="round" />
    <path d="M22 100 Q100 10 178 100" stroke="#FBE4A8" strokeWidth="11" fill="none" strokeLinecap="round" />
    <path d="M34 100 Q100 25 166 100" stroke="#B8D6BE" strokeWidth="11" fill="none" strokeLinecap="round" />
    <path d="M46 100 Q100 40 154 100" stroke="#B8D6E8" strokeWidth="11" fill="none" strokeLinecap="round" />
    <path d="M58 100 Q100 55 142 100" stroke="#D9C7EC" strokeWidth="11" fill="none" strokeLinecap="round" />
  </svg>
);

export const Flower = ({ className = "", size = 60, color = "#FBC4D0" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 60 60" fill="none">
    <circle cx="30" cy="14" r="9" fill={color} stroke="#5B4F46" strokeWidth="1.5" />
    <circle cx="46" cy="30" r="9" fill={color} stroke="#5B4F46" strokeWidth="1.5" />
    <circle cx="30" cy="46" r="9" fill={color} stroke="#5B4F46" strokeWidth="1.5" />
    <circle cx="14" cy="30" r="9" fill={color} stroke="#5B4F46" strokeWidth="1.5" />
    <circle cx="30" cy="30" r="8" fill="#FBE4A8" stroke="#5B4F46" strokeWidth="1.5" />
  </svg>
);

export const Squiggle = ({ className = "", color = "#F4A899", width = 100 }) => (
  <svg className={className} width={width} height="14" viewBox="0 0 100 14" fill="none">
    <path
      d="M2 7 Q12 1 22 7 T42 7 T62 7 T82 7 T98 7"
      stroke={color}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Smiley = ({ className = "", size = 50, color = "#FBE4A8" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 50 50" fill="none">
    <circle cx="25" cy="25" r="20" fill={color} stroke="#5B4F46" strokeWidth="2" />
    <circle cx="19" cy="22" r="2" fill="#5B4F46" />
    <circle cx="31" cy="22" r="2" fill="#5B4F46" />
    <path d="M17 30 Q25 36 33 30" stroke="#5B4F46" strokeWidth="2" fill="none" strokeLinecap="round" />
    <ellipse cx="14" cy="29" rx="3" ry="2" fill="#F4A899" opacity="0.6" />
    <ellipse cx="36" cy="29" rx="3" ry="2" fill="#F4A899" opacity="0.6" />
  </svg>
);

export const SpiralCircle = ({ className = "", size = 60, color = "#B8D6E8" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 60 60" fill="none">
    <path
      d="M30 30 Q30 18 18 18 Q6 18 6 30 Q6 48 30 48 Q54 48 54 30 Q54 12 30 12 Q12 12 12 30"
      stroke={color}
      strokeWidth="3"
      fill="none"
      strokeLinecap="round"
    />
  </svg>
);

export const Dots = ({ className = "", color = "#F4A899" }) => (
  <svg className={className} width="80" height="20" viewBox="0 0 80 20" fill="none">
    <circle cx="8" cy="10" r="4" fill={color} />
    <circle cx="28" cy="10" r="4" fill={color} />
    <circle cx="48" cy="10" r="4" fill={color} />
    <circle cx="68" cy="10" r="4" fill={color} />
  </svg>
);

export const PaperPlane = ({ className = "", size = 50, color = "#B8D6E8" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 50 50" fill="none">
    <path
      d="M5 22 L45 5 L38 45 L22 30 L5 22 Z"
      fill={color}
      stroke="#5B4F46"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path d="M22 30 L45 5" stroke="#5B4F46" strokeWidth="1.5" fill="none" />
  </svg>
);

export const Balloon = ({ className = "", size = 60, color = "#FBC4D0" }) => (
  <svg className={className} width={size} height={size} viewBox="0 0 60 80" fill="none">
    <ellipse cx="30" cy="28" rx="20" ry="24" fill={color} stroke="#5B4F46" strokeWidth="1.5" />
    <path d="M28 52 L32 52 L30 56 Z" fill="#5B4F46" />
    <path d="M30 56 Q26 65 30 75" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <ellipse cx="23" cy="22" rx="3" ry="5" fill="white" opacity="0.6" />
  </svg>
);

// Hand-drawn child holding balloons
export const ChildWithBalloons = ({ className = "", size = 160 }) => (
  <svg className={className} width={size} height={size * 1.4} viewBox="0 0 120 170" fill="none">
    {/* Balloon strings */}
    <path d="M68 75 Q72 50 78 25" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M68 75 Q66 45 60 20" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M68 75 Q78 55 92 35" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />

    {/* Balloons */}
    <ellipse cx="78" cy="20" rx="13" ry="16" fill="#FBC4D0" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="74" cy="15" rx="2.5" ry="4" fill="white" opacity="0.6" />
    <ellipse cx="60" cy="15" rx="11" ry="14" fill="#FBE4A8" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="57" cy="11" rx="2" ry="3.5" fill="white" opacity="0.6" />
    <ellipse cx="92" cy="30" rx="11" ry="14" fill="#B8D6E8" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="89" cy="26" rx="2" ry="3.5" fill="white" opacity="0.6" />

    {/* Head */}
    <circle cx="50" cy="90" r="18" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.8" />
    {/* Hair */}
    <path d="M34 84 Q38 70 50 70 Q62 70 66 84 Q63 80 56 80 Q50 78 44 80 Q38 80 34 84 Z" fill="#5B4F46" />
    {/* Eyes */}
    <circle cx="44" cy="91" r="1.8" fill="#5B4F46" />
    <circle cx="56" cy="91" r="1.8" fill="#5B4F46" />
    {/* Cheeks */}
    <ellipse cx="40" cy="97" rx="3" ry="2" fill="#FBC4D0" opacity="0.7" />
    <ellipse cx="60" cy="97" rx="3" ry="2" fill="#FBC4D0" opacity="0.7" />
    {/* Smile */}
    <path d="M44 100 Q50 105 56 100" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />

    {/* Body (shirt) */}
    <path
      d="M35 110 Q30 115 30 135 L70 135 Q70 115 65 110 Q60 108 50 108 Q40 108 35 110 Z"
      fill="#B8D6BE"
      stroke="#5B4F46"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    {/* Arm holding balloons */}
    <path d="M65 115 Q72 95 68 78" stroke="#5B4F46" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <circle cx="68" cy="76" r="3" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.5" />
    {/* Other arm */}
    <path d="M35 115 Q28 122 30 132" stroke="#5B4F46" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <circle cx="30" cy="134" r="3" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.5" />

    {/* Legs */}
    <path d="M42 135 L40 158" stroke="#5B4F46" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M58 135 L60 158" stroke="#5B4F46" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Shoes */}
    <ellipse cx="38" cy="160" rx="6" ry="3" fill="#F4A899" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="62" cy="160" rx="6" ry="3" fill="#F4A899" stroke="#5B4F46" strokeWidth="1.5" />
  </svg>
);

// Second child variant — different colors and pose
export const ChildWithBalloons2 = ({ className = "", size = 160 }) => (
  <svg className={className} width={size} height={size * 1.4} viewBox="0 0 120 170" fill="none">
    {/* Balloon strings */}
    <path d="M52 75 Q48 50 42 25" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />
    <path d="M52 75 Q55 45 60 20" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />

    {/* Balloons */}
    <ellipse cx="42" cy="20" rx="13" ry="16" fill="#D9C7EC" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="38" cy="15" rx="2.5" ry="4" fill="white" opacity="0.6" />
    <ellipse cx="60" cy="15" rx="11" ry="14" fill="#F4A899" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="57" cy="11" rx="2" ry="3.5" fill="white" opacity="0.6" />

    {/* Head */}
    <circle cx="65" cy="90" r="18" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.8" />
    {/* Hair - pigtails */}
    <path d="M49 84 Q53 68 65 68 Q77 68 81 84" stroke="#5B4F46" strokeWidth="1.8" fill="#5B4F46" />
    <circle cx="46" cy="86" r="5" fill="#5B4F46" />
    <circle cx="84" cy="86" r="5" fill="#5B4F46" />
    {/* Bows on pigtails */}
    <path d="M42 84 L40 80 L44 81 L42 84" fill="#FBC4D0" stroke="#5B4F46" strokeWidth="1" />
    <path d="M88 84 L86 80 L90 81 L88 84" fill="#FBC4D0" stroke="#5B4F46" strokeWidth="1" />
    {/* Eyes */}
    <circle cx="59" cy="91" r="1.8" fill="#5B4F46" />
    <circle cx="71" cy="91" r="1.8" fill="#5B4F46" />
    {/* Cheeks */}
    <ellipse cx="55" cy="97" rx="3" ry="2" fill="#FBC4D0" opacity="0.7" />
    <ellipse cx="75" cy="97" rx="3" ry="2" fill="#FBC4D0" opacity="0.7" />
    {/* Smile */}
    <path d="M59 100 Q65 105 71 100" stroke="#5B4F46" strokeWidth="1.5" fill="none" strokeLinecap="round" />

    {/* Body (dress) */}
    <path
      d="M50 110 Q45 115 40 138 L90 138 Q85 115 80 110 Q75 108 65 108 Q55 108 50 110 Z"
      fill="#FBC4D0"
      stroke="#5B4F46"
      strokeWidth="1.8"
      strokeLinejoin="round"
    />
    {/* Dots on dress */}
    <circle cx="55" cy="120" r="1.5" fill="#5B4F46" />
    <circle cx="72" cy="123" r="1.5" fill="#5B4F46" />
    <circle cx="64" cy="130" r="1.5" fill="#5B4F46" />

    {/* Arm holding balloons */}
    <path d="M50 115 Q53 95 52 78" stroke="#5B4F46" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <circle cx="52" cy="76" r="3" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.5" />
    {/* Other arm */}
    <path d="M80 115 Q88 122 86 132" stroke="#5B4F46" strokeWidth="1.8" fill="none" strokeLinecap="round" />
    <circle cx="86" cy="134" r="3" fill="#FFE4D0" stroke="#5B4F46" strokeWidth="1.5" />

    {/* Legs */}
    <path d="M55 138 L52 158" stroke="#5B4F46" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    <path d="M75 138 L78 158" stroke="#5B4F46" strokeWidth="2.5" fill="none" strokeLinecap="round" />
    {/* Shoes */}
    <ellipse cx="50" cy="160" rx="6" ry="3" fill="#B8D6E8" stroke="#5B4F46" strokeWidth="1.5" />
    <ellipse cx="80" cy="160" rx="6" ry="3" fill="#B8D6E8" stroke="#5B4F46" strokeWidth="1.5" />
  </svg>
);
